import React, { useState, useEffect, Suspense } from 'react';
import { Col, Divider, Row } from 'antd';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaInstagram, FaYoutube, FaCcMastercard, FaCcPaypal, FaCcVisa, FaCcAmex, FaLinkedinIn, FaWhatsapp, FaHeadphones, FaPhoneAlt } from "react-icons/fa";
import { getFlightDomesticList, getFlightInternationalList } from '../services/flight/flightServices';
import moment from 'moment';

const Footer = () => {

  const PlaceholderList = () => (
    <ul className="footer-list">
      {[...Array(5)].map((_, index) => (
        <li key={index} style={{ height: "20px", backgroundColor: "#f0f0f0", borderRadius: "4px", marginBottom: "5px" }}></li>
      ))}
    </ul>
  );

  const currentYear = new Date().getFullYear();

  const [visibleSections, setVisibleSections] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const toggleVisibility = (section) => {
    setVisibleSections((prevVisibleSections) => ({
      ...prevVisibleSections,
      [section]: !prevVisibleSections[section],
    }));
  };

  const [domesticData, setDomesticData] = useState([]);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const fetchDomesticData = async () => {
    try {
      const data = await getFlightDomesticList();
      setDomesticData(data?.data || []);
    } catch (err) {
      setError('Failed to fetch domestic flights');
    }
  };

  const [internationalData, setInternationalData] = useState(null);

  const fetchinternationalData = async () => {
    try {
      const data = await getFlightInternationalList();
      setInternationalData(data?.data);
    } catch (err) {
      setError('Failed to fetch domestic flights');
    }
  };

  useEffect(() => {
    fetchDomesticData();
    fetchinternationalData();
  }, []);

  const formattedTomorrow = moment().add(1, 'days').format('DD/MMM/YYYY');
  const handleFlightClick = (flight) => {
    sessionStorage.setItem('selectFromCity', JSON.stringify(flight?.from_city));
    sessionStorage.setItem('selectFromCityName', JSON.stringify(flight?.from_city_airport));
    sessionStorage.setItem('selectTOCity', JSON.stringify(flight?.to_city));
    sessionStorage.setItem('selectTOCityName', JSON.stringify(flight?.to_city_airport));
    sessionStorage.setItem('seatTypeflight', JSON.stringify("ECONOMY"));
    sessionStorage.setItem('returnFlight', JSON.stringify('oneWay'));
    sessionStorage.setItem('DepartureFlight', JSON.stringify(formattedTomorrow));
    sessionStorage.setItem('selectAdultsflight', JSON.stringify(1));
    sessionStorage.setItem('selectChildflight', JSON.stringify(0));
    sessionStorage.setItem('selectInfantsflight', JSON.stringify(0));
    const formattedFromCity = flight?.from_city?.toLowerCase().replace(/\s+/g, '-');
    const formattedToCity = flight?.to_city?.toLowerCase().replace(/\s+/g, '-');
    const urlIdDynamic = `${formattedFromCity}-to-${formattedToCity}-flights`;
    navigate(`/flights/${urlIdDynamic}`);
  };

  const location = useLocation();
  const path = location.pathname;
  const isFlightReviewPageDesktop = path === "/flight-review";
  const isFlightResultPage = path.startsWith("/flights/") && path.split("/")[2];
  const isFlightReviewPage = ["/flight-review", "/hotel-details", "/hotel-payment"].includes(path);
  const FaWhatsappURL = ["/holiday", "/package-home"].some(p => path.startsWith(p)) || path.startsWith("/destination") || path.startsWith("/package") || path.startsWith("/package-details");
  const FaHolidayMobileViewHide = ["/package-home"].some(p => path.startsWith(p)) || path.startsWith("/destination") || path.startsWith("/package") || path.startsWith("/package-details");;
  const shouldHideFooter = isMobile && isFlightReviewPage;

  return (
    <>

      {!isFlightResultPage && !shouldHideFooter && (
        <>
          <div className={`footer-area ptb-70 pb-50 ${isFlightReviewPage || FaHolidayMobileViewHide ? "d-md-block d-none" : ""}`}>
            <div className="container">
              <Row gutter={20}>
                <Col xs={24} md={6}>
                  <h2 className="mt-0" onClick={() => isMobile && toggleVisibility('aboutUs')}>About Us</h2>
                  {(visibleSections.aboutUs || !isMobile) && (
                    <div className="footer-list">
                      <Link aria-label="Home" to="">Home</Link>
                      <Link aria-label="About Us" to="/about-us">About Us</Link>
                      <Link aria-label="Book Flights" to="/flights">Book Flights</Link>
                      <Link aria-label="Book Hotels" to="/hotels">Book Hotels</Link>
                      <Link aria-label="Holiday Package" to="/holiday">Book Holidays</Link>
                    </div>
                  )}
                </Col>

                <Col xs={24} md={6}>
                  <h2 onClick={() => isMobile && toggleVisibility('siteInfo')}>Site Information</h2>
                  {(visibleSections.siteInfo || !isMobile) && (
                    <div className="footer-list">
                      <Link aria-label="Contact us" to="/contact-us">Contact Us</Link>
                      <Link aria-label="User Agreement" to="/user-agreement">User Agreement</Link>
                      <Link aria-label="Privacy Policy" to="/privacy-policy">Privacy Policy</Link>
                      <Link aria-label="Terms and Conditions" to="/terms-conditions">Terms & Conditions</Link>
                      <Link aria-label="Certificates" to="/certificates">Certificates</Link>
                    </div>
                  )}
                </Col>

                <Col xs={24} md={6}>
                  <h2 onClick={() => isMobile && toggleVisibility('siteDirectory')}>Site Directory</h2>
                  {(visibleSections.siteDirectory || !isMobile) && (
                    <div className="footer-list">
                      <Link aria-label="International destinations" to="/popular-international-destinations">International Destinations</Link>
                      <Link aria-label="Domestic destinations" to="/popular-domestic-destinations">Domestic Destinations</Link>
                      <Link aria-label="Holidays by Destination" to="/holidays-by-destination">Holidays by Destination</Link>
                      <Link aria-label="Holidays by Theme" to="/holiday-packages-by-theme">Holidays by Theme</Link>
                      <Link aria-label="Domestic Hotels" to="/hotels">Top Domestic Hotels</Link>
                    </div>
                  )}
                </Col>
                <Col xs={24} md={6}>
                  <h2 onClick={() => isMobile && toggleVisibility('domesticFlight')}>Domestic Flight</h2>
                  {(visibleSections.domesticFlight || !isMobile) && (
                    <Suspense fallback={<PlaceholderList />}>
                      <div className="footer-list">
                        {domesticData?.slice(0, 5).map((flight, index) => (
                          <Link
                            key={`${flight.from_city}-${flight.to_city}-${index}`}
                            to={`/flights/${flight.from_city.toLowerCase()}-to-${flight.to_city.toLowerCase()}-flights`}
                            aria-label={`${flight.from_city} to ${flight.to_city} Flights`}
                            className="footer-link" // optional class
                          >
                            {flight.from_city} to {flight.to_city} Flights
                          </Link>
                        ))}
                      </div>
                    </Suspense>
                  )}
                </Col>
                {!isFlightReviewPageDesktop &&
                  <>
                    <Divider />
                    <Col md={24}>
                      <div className="flights_links">
                        <p>Popular Domestic Destinations  &nbsp;:&nbsp;</p>
                        {domesticData?.slice(0, 23).map((flight, index) => {
                          const formattedFromCity = flight?.from_city?.toLowerCase().replace(/\s+/g, '-');
                          const formattedToCity = flight?.to_city?.toLowerCase().replace(/\s+/g, '-');
                          const dynamicUrl = `/flights/${formattedFromCity}-to-${formattedToCity}-flights`;

                          return (
                            <a
                              key={flight.id || index}
                              href={dynamicUrl}
                              aria-label={`${flight.from_city} to ${flight.to_city}`}
                              onClick={(e) => {
                                e.preventDefault();
                                handleFlightClick(flight);
                              }}
                            >
                              {flight.from_city} to {flight.to_city}
                              {index < Math.min(20, domesticData.length) - 1 && ' | '}
                            </a>
                          );
                        })}
                      </div>

                      <div className="flights_links">
                        <p>Popular International Destinations &nbsp;:&nbsp;</p>
                        {internationalData?.slice(0, 23).map((flight, index) => {
                          const formattedFromCity = flight?.from_city?.toLowerCase().replace(/\s+/g, '-');
                          const formattedToCity = flight?.to_city?.toLowerCase().replace(/\s+/g, '-');
                          const dynamicUrl = `/flights/${formattedFromCity}-to-${formattedToCity}-flights`;

                          return (
                            <a
                              key={flight.id || index}
                              href={dynamicUrl}
                              aria-label={`${flight.from_city} to ${flight.to_city}`}
                              onClick={(e) => {
                                e.preventDefault();
                                handleFlightClick(flight);
                              }}
                            >
                              {flight.from_city} to {flight.to_city}
                              {index < Math.min(20, internationalData.length) - 1 && ' | '}
                            </a>
                          );
                        })}
                      </div>
                    </Col>
                  </>
                }
              </Row>
            </div>
          </div>

          <div className={`footer-bottom ${isFlightReviewPage || FaHolidayMobileViewHide ? "d-md-block d-none" : ""}`}>
            <div className="container">
              <Row gutter={20} className="align-items-center justify-content-center">
                <Col md={8}>
                  <ul className="payment_options d-flex align-items-center gap-10">
                    <li><a href="#" aria-label="Master Card"><FaCcMastercard size={32} style={{ width: "32px", height: "32px" }} /></a></li>
                    <li><a href="#" aria-label="Visa"><FaCcVisa size={32} style={{ width: "32px", height: "32px" }} /></a></li>
                    <li><a href="#" aria-label="Amex"><FaCcAmex size={32} style={{ width: "32px", height: "32px" }} /></a></li>
                    <li><a href="#" aria-label="Paypal"><FaCcPaypal size={32} style={{ width: "32px", height: "32px" }} /></a></li>
                  </ul>
                </Col>
                <Col md={8} className="text-center">
                  <p>© {currentYear} SuperbWorldTrip. All rights reserved</p>
                </Col>
                <Col md={8}>
                  <ul className="social_media d-flex align-items-center justify-content-end">
                    <li><a href="https://www.facebook.com/superbworldtrip" target="_blank" aria-label="Facebook"><FaFacebookF size={24} style={{ width: "24px", height: "24px" }} /></a></li>
                    <li><a href="https://x.com/superbworldtrip" target="_blank" aria-label="Twitter"><FaTwitter size={24} style={{ width: "24px", height: "24px" }} /></a></li>
                    <li><a href="https://www.instagram.com/superbworldtrip/" target="_blank" aria-label="Instagram"><FaInstagram size={24} style={{ width: "24px", height: "24px" }} /></a></li>
                    <li><a href="https://www.youtube.com/@Superbworldtrip/" target="_blank" aria-label="Youtube"><FaYoutube size={24} style={{ width: "24px", height: "24px" }} /></a></li>
                    <li><a href="https://www.linkedin.com/company/superb-world-trip/" target="_blank" aria-label="LinkedIn"><FaLinkedinIn size={24} style={{ width: "24px", height: "24px" }} /></a></li>
                  </ul>
                </Col>
              </Row>
            </div>
          </div>

          {FaWhatsappURL && (
            <>
              <a
                target='_blank'
                className="btn btn-call"
                href="https://api.whatsapp.com/send/?phone=%2B8287938514&amp;text&amp;app_absent=0"
              >
                <FaWhatsapp size={24} style={{ width: "24px", height: "24px" }} />
              </a>

              <a
                target="_blank"
                className="btn btn-call2 d-flex align-items-center"
                href="tel:+919312241999"
              >
                <FaPhoneAlt size={24} style={{ width: "24px", height: "24px" }} />
                <p className='d-md-block d-none'>Call Us Now</p>
              </a>
            </>
          )}
        </>
      )}

    </>
  )
}

export default Footer